import { GetAllFieldAssessmentsUseCaseInterface } from 'domain/usecases';
import { TableColumn } from 'react-data-table-component';

export const makeColumnsFieldAssessments = (): TableColumn<
  GetAllFieldAssessmentsUseCaseInterface.Result[number]
>[] => {
  return [
    {
      name: 'Questão',
      selector: (row) => row.name,
      sortable: true,
      sortField: 'name',
      wrap: true,
    },
  ];
};
